import { ref } from 'vue'
import { useGetMe } from '@/composables/get-me'
import { isWalletConnected } from '@/composables/auth.ts'

const isEmailModalOpen = ref(false)

export function useEmailModal() {
  const { meData } = useGetMe()

  const showEmailModal = () => {
    // Only show modal if user doesn't have an email
    if (isWalletConnected.value && !meData.value?.email) {
      isEmailModalOpen.value = true
    }
  }

  const hideEmailModal = () => {
    isEmailModalOpen.value = false
  }

  return {
    isEmailModalOpen,
    showEmailModal,
    hideEmailModal,
  }
}